// extracted by mini-css-extract-plugin
export default {"wrapper":"not-found_wrapper__20wkd","emoji":"not-found_emoji__2SizE"};